<template>
  <span class="inline-block">
    <aha-icon
      v-if="order === 'asc'"
      class="transform rotate-180"
      name="arrow"
      height="12"
      width="12"
      viewBox="0 0 24 24"
    />
    <aha-icon
      v-if="order === 'desc'"
      name="arrow"
      height="12"
      width="12"
      viewBox="0 0 24 24"
    />
  </span>
</template>

<script>

export default {
  props: {
    order: {
      type: String,
      default: 'asc',
    },
  },
}
</script>
